import { render, staticRenderFns } from "./cpuInfo.vue?vue&type=template&id=3bd6086c&"
import script from "./cpuInfo.vue?vue&type=script&lang=js&"
export * from "./cpuInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports